import type { FC } from "react";
import { type Table } from "@tanstack/react-table";
import { Settings2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "~/shared/ui/popover";
import { Switch } from "~/shared/ui/switch";
import { Button } from "~/shared/ui/button";

interface DataTableColumnToggleProps<TData> {
    table: Table<TData>;
    label?: string;
}

function DataTableColumnToggle<TData>({ table, label = "Columns" }: DataTableColumnToggleProps<TData>) {
    const columns = table.getAllColumns().filter((col) => col.getCanHide());

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="outline" size="sm" className="h-11 gap-1.5 md:h-9">
                    <Settings2 className="size-4" />
                    {label}
                </Button>
            </PopoverTrigger>
            <PopoverContent align="end" className="w-56 p-3">
                <div className="flex flex-col gap-2">
                    {columns.map((column) => (
                        <label
                            key={column.id}
                            className="flex cursor-pointer items-center justify-between gap-2 text-sm"
                        >
                            <span className="truncate capitalize">
                                {typeof column.columnDef.header === "string"
                                    ? column.columnDef.header
                                    : column.id}
                            </span>
                            <Switch
                                checked={column.getIsVisible()}
                                onCheckedChange={(v) => column.toggleVisibility(!!v)}
                            />
                        </label>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
}

export default DataTableColumnToggle as FC<DataTableColumnToggleProps<unknown>> &
    typeof DataTableColumnToggle;
export { DataTableColumnToggle };
